module.exports = __webpack_public_path__ + "static/icon-white-2f1c87886662d76948af4ef7095f5cdd.jpg";